/**
 * Small deterministic, platform-independent string hash (FNV-1a 64-bit, hex) for cache identity.
 * Not a security primitive: server code uses SHA-256 for integrity; this keeps the domain
 * package free of Node built-ins so it can run in the browser too.
 */
export function createHashLike(input: string): string {
  let hash = 0xcbf29ce484222325n;
  const prime = 0x100000001b3n;
  const bytes = new TextEncoder().encode(input);
  for (const byte of bytes) {
    hash ^= BigInt(byte);
    hash = (hash * prime) & 0xffffffffffffffffn;
  }
  return hash.toString(16).padStart(16, '0');
}
